<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      :title="'Profile'"
    >
      <template v-slot:button>
        <Button v-if="isEditedProfile" @clicked="toggleEditProfile" variant="default" label="Cancel" />
        <Button v-if="!isEditedProfile" @clicked="toggleEditProfile" variant="primary" label="Edit Profile" />
        <Button v-if="isEditedProfile" @clicked="saveProfile" variant="primary" :label="labelSaveButton" />
      </template>
      <template v-slot:body>
        <ViewProfile v-if="!isEditedProfile" :user="getUser" />
        <EditProfile ref="editProfile" v-if="isEditedProfile" :user="getUser" :emailErrorMessage="emailErrorMessage" :imageErrorMessage="imageErrorMessage" />
      </template>
    </Card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import Card from '@/components/Layout/Card';
import * as moment from 'moment';
import { Button } from '@/components/Layout/Form';
import { ViewProfile, EditProfile } from '../components/Profile';


export default {
  name: 'ProfilePage',
  data: () => ({
    isLoading: false,
    isEditedProfile: false,
    emailErrorMessage: '',
    imageErrorMessage: '',
  }),
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser', 'isAdmin']),
    labelSaveButton() {
      return this.isLoading ? '' : 'Save';
    },
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestDetailUser();
    clevertap.profile.push({
      Site: {
        Name: this.getUser.name, // String
        Identity: this.getUser.id, // String or number
        Email: this.getUser.email, // Email address of the user
        DOB: this.getUser.dob ? moment(this.getUser.dob).toDate() : null,
        'Acquisition Type': 'Website',
        Bio: this.getUser.bio,
        'Registration Date': this.getUser.registration_date,
        'Number of album upload till date': this.getUser.number_of_uploaded_album,
        'Number of song upload till date': this.getUser.number_of_uploaded_song,
        Balance: this.getUser.balance,
        'Total earning till date': this.getUser.earning,
        'First album upload date': this.getUser.first_upload_album_date,
        'Recent album upload': this.getUser.recent_upload_album_date,
        'First song upload date': this.getUser.first_upload_song_date,
        'Recent song upload': this.getUser.recent_upload_song_date,
      },
    });
  },
  watch: {
    getUser: {
      immediate: true,
      handler(user) {
        if ((user.bank === null || user.bank === undefined) && this.isAdmin) {
          this.getUser.bank = Object.assign({}, {
            bank: '',
            account_name: '',
            account_number: '',
            swift_code: '',
          });
        }
      },
    },
  },
  methods: {
    ...mapActions('UserModule', ['requestUpdateProfile', 'requestUpdateBank']),
    ...mapActions('AuthModule', ['requestDetailUser']),
    toggleEditProfile() {
      this.isEditedProfile = !this.isEditedProfile;
      // this.$refs.editProfile.$v.$reset();
    },
    async saveProfile() {
      this.$refs.editProfile.$v.$touch();
      if (!this.$refs.editProfile.$v.$invalid) {
        const profile = this.$refs.editProfile.input;
        this.imageErrorMessage = profile.avatar ? '' : 'Image is required';
        if (this.imageErrorMessage.length === 0) {
          let data = {
            name: profile.name,
            email: profile.email,
            dob: profile.dob,
            bio: !!profile.bio > 0 ? profile.bio.length ? profile.bio : null : null,
            genre: profile.genre,
          };
          this.isLoading = true;
          if (!!profile.avatar && profile.avatar !== this.getUser.avatar) {
            const resultimage = await axios({
              method: 'get',
              url: profile.avatar,
              responseType: 'blob',
            }).then(this.processFileBlob);
            data = { ...data, avatar: resultimage };
          }
          const result = await this.requestUpdateProfile(data);
          if (profile.bank.bank !== '' && profile.bank.account_name !== '' && profile.bank.account_number !== '' && profile.bank.swift_code !== '') {
            await this.requestUpdateBank({
              bank: profile.bank.bank,
              account_name: profile.bank.account_name,
              account_number: profile.bank.account_number,
              swift_code: profile.bank.swift_code,
            });
          }
          if (result) {
            clevertap.profile.push({
              Site: {
                Name: this.getUser.name, // String
                Identity: this.getUser.id, // String or number
                Email: this.getUser.email, // Email address of the user
                DOB: this.getUser.dob ? moment(this.getUser.dob).toDate() : null,
                'Acquisition Type': 'Website',
                Bio: this.getUser.bio,
                'Registration Date': this.getUser.registration_date,
                'Number of album upload till date': this.getUser.number_of_uploaded_album,
                'Number of song upload till date': this.getUser.number_of_uploaded_song,
                Balance: this.getUser.balance,
                'Total earning till date': this.getUser.earning,
                'First album upload date': this.getUser.first_upload_album_date,
                'Recent album upload': this.getUser.recent_upload_album_date,
                'First song upload date': this.getUser.first_upload_song_date,
                'Recent song upload': this.getUser.recent_upload_song_date,
              },
            });
            this.toggleEditProfile();
            this.isLoading = false;
          } else {
            this.emailErrorMessage = this.getMessage;
          }
        }
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
  },
  components: {
    ViewProfile,
    EditProfile,
    Card,
    Button,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue